import { Typography, createTheme, ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";

const theme = createTheme({
  typography: {
    fontFamily: ["Elza Trial", "Bold"].join(","),
  },
});

/**
 * Title component.
 *
 * This component renders a styled title with a specified text and optional custom styles.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.text - The text content of the title.
 * @param {object} [props.sx] - Custom style overrides using the `sx` prop from MUI (optional).
 *
 * @returns {JSX.Element} - The JSX element for the styled title.
 */
function Title({ text, sx }) {
  return (
    <Box sx={sx}>
      <ThemeProvider theme={theme}>
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontSize: "2rem",
              fontWeight: "bold",
              fontStyle: "italic",
            }}
          >
            {text}
          </Typography>
        </Box>
      </ThemeProvider>
    </Box>
  );
}
export default Title;
